import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  return (
    <a
      //   href="https://wa.me/919883218266?text=Hello%20I%20want%20to%20book%20a%20wedding"
      href="https://wa.me/919883218266"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-3 right-2 
           bg-gradient-to-r from-green-400 to-green-600 
           text-white md:p-3 p-2 rounded-full 
           shadow-2xl hover:scale-110 
           transition-all duration-300 z-50"
    >
      <FaWhatsapp size={24} />
    </a>
  );
};

export default WhatsAppButton;
